<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {DateUtil} from "../../../lib/Common/Value/DateUtil";
    import ImageView from "../../../component/common/Image/ImageView.svelte";
    import {EnvStore} from "../../../store/EnvStore";
    import EditButtonView from "../../../component/common/Button/EditButtonView.svelte";
    import {BinaryUtil} from "../../../lib/BinaryUtil";
    import LabelValueView from "../../../component/common/Value/LabelValueView.svelte";

    const dispatcher = createEventDispatcher();

    export let space;
    export let app;

    $: osType = EnvStore.osType;
    $: isSmartPhone = (() => {
        return EnvStore.isSmartPhone($osType);
    })();

    $: thumbnailUrl = (() => {
        if (app == null) {
            return null;
        }
        const latestBinary = app.latest_binary;
        if (latestBinary == null) {
            return null;
        }


        const thumbnailUrl = BinaryUtil.createThumbnailUrl(latestBinary);
        return thumbnailUrl;
    })();

    onMount(() => {
    });

    function onClickEdit(event) {
        dispatcher('edit', {app: app});
    }

</script>

<a class="app-panel-view" href={`/#/space/${space.unique_id}/app/${app.unique_id}`}>
    <div class="head-area">
        {#if !isSmartPhone}
            <div class="edit-area">
                <EditButtonView on:click={onClickEdit}/>
            </div>
        {/if}

        <div class="icon">
            {#if thumbnailUrl != null}
                <ImageView widthPx="50" heightPx="50" src={thumbnailUrl}/>
            {/if}

        </div>
        <div class="name-description">
            <div class="name">
                { app.name }
            </div>
            <div class="description">
                {#if app.description != null}
                    { app.description }
                {/if}
            </div>

        </div>
    </div>

    <div class="information-area">
        <LabelValueView label="バージョンカウント" value={app.version_count}/>
        <LabelValueView label="トータルDL回数" value={app.total_download_count}/>
        <LabelValueView label="最終DL日時" value={app.latest_download_at}/>
    </div>

    <div class="date-area">
        作成日時: { DateUtil.createSimpleDateTimeFormatTextForString(app.created_at)  }
        更新日時: { DateUtil.createSimpleDateTimeFormatTextForString(app.updated_at) }
    </div>

</a>


<style lang="scss">
    .app-panel-view {
        border-radius: 8px;
        border-style: solid;
        border-width: 1px;

        background-color: #f6f6f6;
        filter: drop-shadow(2px 4px 6px #0000);

        display: inline-block;
        width: min(100%, 500px);
        box-sizing: border-box;
        padding-left: 4px;
        padding-right: 4px;
        transition-duration: 0.25s;

        .head-area {
            display: flex;
            gap: 12px;

            .edit-area {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .icon {
                width: 60px;
                height: 60px;

                display: flex;
                align-items: center;
                justify-content: center;
            }

            .name-description {
                flex-grow: 1;
                display: flex;
                flex-direction: column;

                .name {
                    word-break: keep-all;

                }

                .description {
                    flex-grow: 1;
                    margin-top: 0.5em;
                    font-size: 0.5em;
                    opacity: 0.5;
                }


            }
        }

        .information-area {
            font-size: 0.75em;
        }

        .date-area {
            margin-top: 0.5em;
            font-size: 0.6em;
            opacity: 0.5;
            text-align: right;
        }

        &:hover {
            filter: drop-shadow(2px 4px 6px #0009);
            transform: translateY(-5px);


        }

        &:active {
            filter: drop-shadow(2px 4px 6px #0000);
            transform: translateY(0px);
        }


    }
</style>